import { FETCH_USER_ROLES_SUCCESS } from '../actions/UserRolesActions';

export default function userRolesReducer(state = [], action) {
  switch (action.type) {
    case FETCH_USER_ROLES_SUCCESS:
      return [...new Set([...action.payload, ...state])];
    default:
      return state;
  }
}
